import { z } from 'zod';

import { BusinessCardRole } from '@e-origin/shared';

const addressSchema = z.object({
  street: z.string().optional().nullable(),
  streetNr: z.string(),
  zipCode: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
});

const relatedResourceSchema = z.object({
  signedUrl: z.string(),
  fileName: z.string(),
  mediaType: z.string(),
  digestMultibase: z.string().optional().nullable(),
});

export const powerOfAttorneyResponseSchema = z.object({
  poa: z.object({
    customsRepresentative: z.object({
      companyRegistrationNumber: z.string().optional().nullable(),
      vatNumber: z.string().optional().nullable(),
      customsRegistrationNumber: z.string().optional().nullable(),
      address: addressSchema,
    }),
    relatedResources: z.array(relatedResourceSchema),
  }),
  idCard: z.object({
    ownerName: z.string().optional().nullable(),
    expirationDate: z.string(),
    title: z.string().optional().nullable(),
    registrationNumber: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
  }),
  businessLicense: z.object({
    nameEN: z.string().optional().nullable(),
    nameCN: z.string().optional().nullable(),
    registrationNumber: z.string().optional().nullable(),
    bankAccount: z.string().optional().nullable(),
    address: addressSchema,
  }),
  eori: z.object({
    number: z.string().optional().nullable(),
    address: addressSchema,
  }),
  vat: z.object({
    number: z.string().optional().nullable(),
    address: addressSchema,
  }),
});

export const vatRepresentationResponseSchema = z.object({
  vatGuarantee: z.object({
    vatRepresentative: z.object({
      vatNumber: z.string().optional(),
      address: addressSchema,
    }),
    relatedResources: z.array(relatedResourceSchema),
    startingDate: z.date().optional(),
    expirationDate: z.date().optional(),
  }),
  vat: z.object({
    number: z.string().optional(),
    address: addressSchema,
  }),
  eori: z.object({
    number: z.string().optional(),
    address: addressSchema,
  }),
});

export const getBusinessCardResponseSchema = z.object({
  externalId: z.string().optional().nullable(),
  type: z.array(z.literal('Person')),
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  wechatId: z.string().optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  worksFor: z.object({
    type: z.array(z.literal('Organization')),
    role: z.array(z.nativeEnum(BusinessCardRole)),
    id: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    url: z.string().optional().nullable(),
    logo: z.string().optional().nullable(),
    company: z.any().optional().nullable(),
    location: z.object({
      type: z.array(z.string()),
      address: z.object({
        type: z.array(z.literal('PostalAddress')),
        streetAddress: z.string().optional().nullable(),
        addressLocality: z.string().optional().nullable(),
        addressRegion: z.string().optional().nullable(),
        postalCode: z.string().optional().nullable(),
        addressCountry: z.string().optional().nullable(),
      }),
    }),
    email: z.string().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
  }),
  jobTitle: z.string().optional().nullable(),
});
